@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;

  .back-icon {
    height: 12px;
    width: 7.27px;
    margin-right: 12px;
    fill: @setup-page--button--text-color;

    @media screen and (min-width: 600px) {
      display: none;
    }
  }
}

.continue-button {
  width: 113px;
  height: 48px;
}

.later-button {
  height: 48px;
  cursor: pointer;
  padding: @space-12 @space-24;
  @media screen and (max-width: 600px) {
    --light--button--background-color--1: var(--grey-100);
  }
  @media screen and (max-width: 400px) {
    padding: @space-12;
  }
}

.right-container {
  display: flex;
  gap: @space-16;
}

.volume-button-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: @space-16;
  align-self: stretch;
  justify-content: center;
}

.volume-button {
  width: 222px;
  height: 176px;
  padding: @space-12 @space-16;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid var(--grey-300);
  background: var(--grey-000);
  &:focus,
  &:hover {
    background: var(--pine-green-200);
    cursor: pointer;
  }
  &.selected {
    background: var(--pine-green-300);
    border: 1px solid var(--pine-green);
  }
  @media screen and (max-width: 1200px) {
    width: 161px;
    height: 126px;
  }
  @media screen and (max-width: 775px) {
    flex: 1;
    min-width: 40%;
    height: 80px;
    max-width: 50%;
  }
  @media screen and (max-width: 400px) {
    height: 60px;
    max-width: 160px;
  }
}

.selected {
  background: var(--pine-green-300);
  border: 1px solid var(--pine-green);
}

.feature-interest-container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  gap: @space-16;
  @media screen and (max-width: 600px) {
    gap: @space-8;
  }
}

.checkbox-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: @space-16;
}

.feature-interest-button {
  flex: 1;
  min-width: 40%;
  height: 56px;
  padding: @space-12 @space-16;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid var(--grey-300);
  background: var(--grey-000);
  &:focus,
  &:hover {
    background: var(--pine-green-200);
    cursor: pointer;
    --checkbox--unchecked--hover--border-color: var(--pine-green);
  }
  &.selected {
    background: var(--pine-green-300);
    border: 1px solid var(--pine-green);
    --checkbox--checked--background-color: var(--pine-green);
    --checkbox--checked--hover--background-color: var(--pine-green-700);
    --checkbox--checked--hover--border-color: var(--pine-green-700);
  }

  @media screen and (max-width: 775px) {
    min-width: 60%;
  }
}

.company-name-phone-container {
  display: flex;
  flex-flow: column;
  align-items: stretch;
  justify-content: center;
  .input-label {
    > label {
      color: var(--grey-1000);
      font-size: 16px;
      line-height: @space-24;
    }
  }
  @media screen and (min-width: 750px) {
    min-width: 700px;
  }
}

.company-name {
  margin-bottom: @space-16;
}

.phone-explainer {
  margin-top: @space-4;
  color: var(--grey-600);
}
